import LOGIN_US from './login/LOGIN_US'

export const LOGIN = LOGIN_US
